module.exports = __webpack_public_path__ + "media/images/let-you-screen/Button - Back-80d5d6a6ad218c488ab263f27f4a4b23.svg";